export enum QUICK_START_STEP {
  START = 'START',
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  BRAND = 'BRAND',
}
